export const minDurationDefault = 5;
export const maxDurationDefault = 60;
export const widthResolutionDefault = 1080;
export const heightResolutionDefault = 1920;
